import * as React from "react";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import LazyImage from "@insite/mobius/LazyImage";
import Typography from "@insite/mobius/Typography";
import Button from "@insite/mobius/Button";
import parse from "html-react-parser";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import styled, { css } from "styled-components";
// this is used to help ensure that the names match between props.fields and definition.fieldDefinitions[].name
const enum fields {
    linkAbout = "link",
    linkEmail = "linkEmail",
    linkMeeting = "linkMeeting",
    linkLinkedIn = "linkLinkedIn",
    profileImage = "profileImage",
    title = "title",
    subTitle = "subTitle",
    textBtnAbout = "txtBtnAbout",
    textBtnEmail = "txtBtnEmail",
    textBtnMeeting = "txtBtnMeeting",
    textBtnLinkedIn = "txtBtnLinkedIn",
    hideAbout = "hideAbout",
    hideEmail = "hideEmail",
    hideMeeting = "hideMeeting",
    hideLinkedIn = "hideLinkedIn",
}
interface Props extends WidgetProps {
    fields: {
        [fields.linkAbout]:string;
        [fields.linkEmail]:string;
        [fields.linkMeeting]:string;
        [fields.linkLinkedIn]:string;
        [fields.profileImage]:string;
        [fields.title]:string;
        [fields.subTitle]:string;
        [fields.textBtnAbout]:string;
        [fields.textBtnEmail]:string;
        [fields.textBtnMeeting]:string;
        [fields.textBtnLinkedIn]:string;
        [fields.hideAbout]:boolean;
        [fields.hideEmail]:boolean;
        [fields.hideMeeting]:boolean;
        [fields.hideLinkedIn]:boolean;
    };
}


const ProfileWidget: React.FC<Props> = ({ fields}) => {
    if(!fields.title || !fields.subTitle || !fields.txtBtnAbout || !fields.txtBtnEmail || !fields.txtBtnMeeting || !fields.txtBtnLinkedIn)
    {
        return null;
    }

    const container = {
        css:css`
            position:relative
        `,
    }
    const imageResponsive = {
        css:css`
            height: auto;
            width: 100%;
        `,
    }

    const buttonStyle = {
        css:css`
            width: 100%;
            margin-top:5px;
        `,
    }

    const titleStyle = {
        css:css`
            font-weight: bold;
            color: #016EAF;
        `,
    }

    const subTitleStyle = {
        css:css`
            font-weight: normal;
            margin-bottom: 2rem;
        `,
    }

    const hideButton = {
        css:css`
            display:none;
        `,
    }

    let ButtonVisibility;
    if(fields.hideAbout)
    {
        ButtonVisibility = hideButton;
    }
    else if(fields.hideEmail)
    {
        ButtonVisibility = hideButton;
    }
    else if(fields.hideMeeting)
    {
        ButtonVisibility = hideButton;
    }
    else if(fields.linkLinkedIn)
    {

    }
    else if(fields.hideLinkedIn)
    {
        ButtonVisibility = hideButton;
    }

    return(
        <StyledWrapper {...container}>
            <StyledWrapper>
                <Typography {...titleStyle} variant="h3">{parse(fields.title, parserOptions)}</Typography>
            </StyledWrapper>

            <StyledWrapper>
                <Typography {...subTitleStyle} variant="h5">{parse(fields.subTitle, parserOptions)}</Typography>
            </StyledWrapper>
            <StyledWrapper>
                <LazyImage {...imageResponsive} src={fields.profileImage}></LazyImage>
            </StyledWrapper>

            <StyledWrapper >
                <Button {...ButtonVisibility} {...buttonStyle} color="#F06907" style={{color:"white"}}>{parse(fields.txtBtnAbout, parserOptions)}</Button>
            </StyledWrapper>
            <StyledWrapper>
                <Button {...ButtonVisibility} {...buttonStyle}  color="#F06907" buttonType="outline" onClick={() => window.open(`mailto:${fields.linkEmail}`)}>{parse(fields.txtBtnEmail, parserOptions)}</Button>
            </StyledWrapper>
            <StyledWrapper>
                <Button {...ButtonVisibility} {...buttonStyle}  color="#F06907" buttonType="outline">{parse(fields.txtBtnMeeting, parserOptions)}</Button>
            </StyledWrapper>
            <StyledWrapper>
                <Button {...ButtonVisibility} {...buttonStyle} color="#F06907" buttonType="outline" onClick={() => window.open(fields.linkLinkedIn, '_blank')} >{parse(fields.txtBtnLinkedIn, parserOptions)}</Button>
            </StyledWrapper>

        </StyledWrapper>

        
    
    );
};
const widgetModule: WidgetModule = {
    component: ProfileWidget,
    definition: {
        fieldDefinitions:[
            {
                fieldType: "Translatable",
                name:fields.title,
                editorTemplate: "TextField",
                displayName: "Profile Title",
                defaultValue: "",
            },
            {
                name: fields.subTitle,
                fieldType:"Translatable",
                editorTemplate: "TextField",
                displayName: "Profile sub Title",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.profileImage,
                editorTemplate: "ImagePickerField",
                defaultValue: ""
            },
            {
                fieldType: "General",
                name: fields.hideAbout,
                editorTemplate: "CheckboxField",
                displayName: "Hide About Button",
                defaultValue: false,
            },
            {
                fieldType:"Translatable",
                name:fields.textBtnAbout,
                displayName: "About Button Text",
                editorTemplate: "TextField",
                defaultValue: "About",
            },
            {
                fieldType:"Translatable",
                name:fields.linkAbout,
                displayName: "About Link",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.hideEmail,
                editorTemplate: "CheckboxField",
                displayName: "Hide Email Button",
                defaultValue: false,
            },
            {
                fieldType: "Translatable",
                name: fields.textBtnEmail,
                displayName: "Email Button Text",
                editorTemplate: "TextField",
                defaultValue: "Email",
            },
            {
                fieldType: "Translatable",
                name: fields.linkEmail,
                displayName: "Email Link",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.hideMeeting,
                editorTemplate: "CheckboxField",
                displayName: "Hide Meeting Button",
                defaultValue: false,
            },
            {
                fieldType: "Translatable",
                name: fields.textBtnMeeting,
                displayName: "Book a Meeting Button Text",
                editorTemplate: "TextField",
                defaultValue: "Book a Meeting",
            },
            {
                fieldType: "Translatable",
                name: fields.linkMeeting,
                displayName: "Book a Meeting Link",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.hideLinkedIn,
                editorTemplate: "CheckboxField",
                displayName: "Hide LinkedIn Button",
                defaultValue: false,
            },
            {
                fieldType: "Translatable",
                name: fields.textBtnLinkedIn,
                displayName: "LinkedIn Button Text",
                editorTemplate: "TextField",
                defaultValue: "LinkedIn",
            },
            {
                fieldType: "Translatable",
                name: fields.linkLinkedIn,
                displayName: "LinkedIn Link",
                editorTemplate: "TextField",
                defaultValue: "",
            },
        ],
        group: "Common",
        
    },
};

export default widgetModule;